const ComponentReceiptAction = (() => {

    class Core {

        constructor() {
            
            this.receiptAction = document.querySelector('.receipt-action') || false;          
        
        }

    }


    /**
     * Загрузить фото чека
     */
    class PhotoReceipt extends Core {

        constructor() {
            
            super();            
            this.el = document.querySelector('.js-photo-receipt') || false;


            if (this.el !== false) {
                
                this.variables();
                this.event();
                
            }
            
        }


        variables() {

            this.stepArray = Array.from(document.querySelectorAll('.photo-receipt__step'));
            this.preview = this.el.querySelector('.photo-receipt__preview');
            this.buttonLoadPhoto = this.el.querySelector('.receipt-action__btn.--photo');
            this.buttonLoadMorePhoto = this.el.querySelector('.--photo-load-more');

        }
        
        
        event() {
            
            this.el.addEventListener('submit', this.listener_submit_photo.bind(this), false);
            this.buttonLoadPhoto.addEventListener('change', this.listener_load_photo.bind(this), false);
            this.buttonLoadMorePhoto.addEventListener('click', () => this.method_step_active('--start'), false);

        }


        listener_submit_photo(event) {

            let target = event.target;


            this.method_step_active('--end'); // show end
            
            event.preventDefault();

        }


        listener_load_photo(event) {

            let target = event.target,
                file = target.files[0],
                reader = new FileReader();
            

            reader.onloadend = () => {
                
                this.preview.src = reader.result;
                this.method_step_active('--preview'); // show preview
            
            }

            if (file) {
            
                reader.readAsDataURL(file);
            
            } else {
                
                this.preview.src = "";
            
            }

        }


        method_step_active(type) {

            this.stepArray.find((step, index) => {

                if (step.classList.contains(type) == true) {

                    this.stepActive = {
                        el: step,
                        index: index
                    };

                    step.classList.add('--active');

                } else {

                    step.classList.remove('--active');

                }

            })

        }

    }


    /**
     * Сканирование QR-кода
     */
    class QrScannerReceipt extends Core {

        constructor() {
            
            super();            
            this.el = document.querySelector('.js-qr-scanner') || false;
            

            if (this.el !== false) {
                
                this.variables();
                this.build();
                this.event();

            }
        
        }


        variables() {

            this.result = null;
            this.qrScanner = null;
            this.preview = this.el.querySelector('.qr-scanner__preview');
            this.video = this.preview.querySelector('.qr-scanner__video');
            this.buttonStart = this.el.querySelector('.--qr-start') || false;

        }


        build() {

            let notificationElement = null;

            notificationElement = document.createElement('div');
            notificationElement.classList.add('qr-scanner__notification');
            

            this.el.appendChild(notificationElement);
            this.notification = this.el.querySelector('.qr-scanner__notification');
        }

    
        event() {
            
            this.buttonStart.addEventListener('click', this.listener_start.bind(this), false);
            
            if (this.receiptAction !== false) {

                this.receiptAction.addEventListener('popup toggle', this.listener_popup.bind(this), false);

            }
            
        }
    

        listener_popup(event) {

            // popup hide
            if (event.detail.hidden == true) {

                this.method_stop();

            }

        }


        listener_start() {

            this.method_init();
            this.method_start();

        }


        method_init() {

            this.qrScanner = new QrScanner(this.video, result => {

                this.result = result;

                this.notification.setAttribute('data-type', 'success');
                this.notification.innerHTML = `<strong>QR-код отсканирован</strong>`;
                this.notification.classList.add('--show');

            }, {

                onDecodeError: error => {
                    
                    this.notification.setAttribute('data-type', 'error');
                    this.notification.innerHTML = `<strong>QR-код не найден</strong>`;
                    this.notification.classList.add('--show');

                },

                highlightScanRegion: true,
                highlightCodeOutline: true,

            });

        }

        
        method_start() {

            if (this.qrScanner !== null) {

                this.qrScanner.start().then(() => {

                    this.preview.classList.add('--show');

                });
            
            }

        }


        method_stop() {

            if (this.qrScanner !== null) {

                this.qrScanner.stop();
                this.qrScanner.destroy();

                this.preview.classList.remove('--show');
                this.notification.classList.remove('--show');
            
            }

        }

    }


    class Init {

        constructor() {

            this.object = {};
            this.object.photo   = new PhotoReceipt();
            this.object.scanner = new QrScannerReceipt();
            
            return this.object;

        }

    } 


    let active = null;

    const init          = () => active = new Init();
    const scannerResult = () => active.scanner.result;


    return { init, scannerResult };

})();


window.ComponentReceiptAction = ComponentReceiptAction;


export { ComponentReceiptAction };